/**
 * Imagen de cada montaje para el configurador. Los packs se enseñan con foto
 * de boda real; las estructuras a medida, con las mismas simulaciones que la
 * galería de `/bodas` (`Setups` en `src/components/landing/Sections.tsx`).
 */
import setupArco from "@/assets/setup-arco.webp";
import setupColumnas from "@/assets/setup-columnas.webp";
import setupMonolito from "@/assets/setup-monolito.webp";
import setupPortico from "@/assets/setup-portico.webp";
import setupTriangulo from "@/assets/setup-triangulo.webp";
import { MONTAJES, type Montaje, type MontajeId } from "@/domain/cierre";

/** `vertical`: foto más alta que ancha (Experience, 4:5) que se enseña entera sobre un fondo hecho con ella misma. */
export type Encuadre = "horizontal" | "vertical";

export interface VisualMontaje {
  imagen: string;
  encuadre: Encuadre;
  alt: string;
}

const VISUALES: Record<MontajeId, VisualMontaje> = {
  experience: {
    imagen: "/presentacion/pack-experience.webp",
    encuadre: "vertical",
    alt: "Cabina de madera con el puente de iluminación del pack Experience en una boda real",
  },
  signature: {
    imagen: "/presentacion/pack-signature.webp",
    encuadre: "horizontal",
    alt: "Montaje del pack Signature con cabezas móviles sobre torres de madera en una boda real",
  },
  columnas: {
    imagen: setupColumnas,
    encuadre: "horizontal",
    alt: "Patio de noche con dos columnas de madera iluminadas a los lados de la cabina",
  },
  monolito: {
    imagen: setupMonolito,
    encuadre: "horizontal",
    alt: "El mismo patio con un monolito de dos paneles de pantalla detrás de la cabina",
  },
  portico: {
    imagen: setupPortico,
    encuadre: "horizontal",
    alt: "El mismo patio con una estructura cuadrada que enmarca la cabina",
  },
  triangulo: {
    imagen: setupTriangulo,
    encuadre: "horizontal",
    alt: "El mismo patio con dos triángulos de estructura encajados alrededor de la cabina",
  },
  arco: {
    imagen: setupArco,
    encuadre: "horizontal",
    alt: "El mismo patio con un aro de estructura casi cerrado alrededor de la cabina",
  },
};

export type MontajeConVisual = Montaje & VisualMontaje;

export const MONTAJES_VISUALES: readonly MontajeConVisual[] = MONTAJES.map((montaje) => ({
  ...montaje,
  ...VISUALES[montaje.id],
}));

export const IMAGEN_COLUMNAS_CON_TARIMA = setupColumnas;
